import BillingAreaGuard, { useBillingAreas } from "./BillingAreaGuard";
import ContrattiConsulenza from "./ContrattiConsulenza";
import UsciteTecnici from "./UsciteTecnici";
import ExtraClienti from "./ExtraClienti";
import useExtraAccess from "./useExtraAccess";
import { clientName } from "../utils/clientName";
import { formatCodiceAgo } from "../utils/codiceAgo";
import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import unsplash from "../api/unsplash";
import { useNavigate } from "react-router-dom";
import {
  DataGridPro,
  itIT,
  GridToolbarContainer,
  GridToolbarQuickFilter,
} from "../utils/PersistedDataGridPro";
import { CustomFooterPersonalized } from "../utils/CustomFooterPersonalized";
import {
  getImageDataUrl,
  resizeImageForStorage,
} from "../utils/resizeImageForStorage";
import {
  TextField,
  Alert,
  Box,
  Typography,
  Tab,
  Tabs,
  Grid,
  Checkbox,
  FormControlLabel,
  Card,
  CardContent,
  CardHeader,
  CircularProgress,
  Button,
  CardMedia,
  Divider,
  CardActionArea,
  Tooltip,
  IconButton,
  Avatar,
  Chip,
  Select,
  FormControl,
  InputLabel,
  MenuItem,
  Popover,
  DialogTitle,
  DialogContent,
  Dialog,
  DialogActions,
  Zoom,
  LinearProgress,
} from "@mui/material";
import SmartToyIcon from "@mui/icons-material/SmartToy";

import Lavoratori from "./Lavoratori";
import {
  AccountCircle,
  AttachFile,
  Home,
  Work,
  Engineering,
  MedicalServices,
  Euro,
  School,
  LocationOn,
  Check,
  ArrowBack,
  People,
  Error,
  Info,
  Upload,
  Circle,
  NewReleases,
  CheckCircle,
  TimeToLeave,
  DeleteOutline,
  Add,
  Close,
  EditOutlined,
} from "@mui/icons-material";
import SpeakerNotesRoundedIcon from "@mui/icons-material/SpeakerNotesRounded";

import { useLocation } from "react-router";
import Mansioni from "./Mansioni";
import Allegati from "./Allegati";
import moment from "moment";
import Sedi from "./Sedi";
import MediciCliente from "./MediciCliente";
import FatturazioneMedicina from "./FatturazioneMedicina";
import CorsiCliente from "./CorsiCliente";
import Sopralluoghi from "./DettaglioCliente/Sopralluoghi";
import GlobalSnackbar from "./Snackbar";
import DashboardIcon from "@mui/icons-material/Dashboard";
import Memo from "./Memo";
import PercentIcon from "@mui/icons-material/Percent";
import "moment/locale/it";

import {
  LocalizationProvider,
  DatePicker,
  PickersDay,
  TimePicker,
} from "@mui/x-date-pickers";
import { AdapterMoment as DateAdapter } from "@mui/x-date-pickers/AdapterMoment";
import ExtraMedici from "./ExtraMedici";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Zoom timeout={2000} in={true} ref={ref} {...props} />;
});

const ClientDetail = (props) => {
  const location = useLocation();
  const detailStateKey = "client-detail-state";
  const [restoredState] = useState(() => {
    try {
      const stored = localStorage.getItem(detailStateKey);
      return stored ? JSON.parse(stored) : null;
    } catch (error) {
      return null;
    }
  });
  const state = location.state || restoredState || {};
  const storageKey = React.useMemo(() => {
    const clienteId = state?.idC || state?.cliente?.ID;
    return `client-detail-billing-v2-tab:${clienteId || "default"}`;
  }, [state?.idC, state?.cliente?.ID]);
  const [cliente, setCliente] = useState({
    Logo: "",
    ID: 0,
    RagioneSociale: "",
    UtenteSicurezza: "",
    UtenteAssociato: "",
    UtenteFormazione: "",
    TipologiaAzienda: "",
    CodiceIdent: "",
    CodiceAgo: "",
    Email: "",
    CF: "",
    PIVA: "",
    Telefono: "",
    CodiceATECO: "",
    CDC: "",
    SedeIndirizzo: "",
    SedeLocalita: "",
    SedeCAP: "",
    PostIndirizzo: "",
    PostLocalita: "",
    PostCAP: "",
    GestioneCorsi: "",
    GestioneSopralluoghi: "",
    InvioSollMedico: "",
    Notarizzazione: "",
    FatturaVisiteMediche: "",
    Cessato: "",
    Sicurezza: "",
    NomeReferente: "",
    Gruppo: "",
  });
  const clienteId = state.idC || cliente.ID;
  const ragioneSociale = clientName(cliente, state);
  const [logo, setLogo] = useState("");
  const [oldCliente, setOldCliente] = useState();
  const [value, setValue] = React.useState(0);
  const [lavoratori, setLavoratori] = useState([]);
  const [loadingLav, setLoadingLav] = useState(true);
  const [loadingNuoviLav, setLoadingNuoviLav] = useState(true);
  const [nuoviLav, setNuoviLav] = useState([]);

  const [loadingVis, setLoadingVis] = useState(true);
  const [loadingNuov, setLoadingNuov] = useState(true);

  const [loadingScadutiMedicina, setLoadingScadutiMedicina] = useState(true);
  const [lavoratoriScadutiMedicina, setLavScadutiMedicina] = useState([]);

  const [utenti, setUtenti] = useState([]);
  const [utentiSicurezza, setUtentiSicurezza] = useState([]);
  const [utentiFormazione, setUtentiFormazione] = useState([]);
  const [memoVisibili, setMemoVisibili] = useState([]);
  const [loadingMemo, setLoadingMemo] = useState(true);
  const billingAreas = useBillingAreas();
  const extraAccess = useExtraAccess();
  const [user, setUser] = useState({
    Formazione: 0,
    Medicina: 0,
    Sicurezza: 0,
    username: "",
  });

  const [TipologiaAzienda, setTipologiaAzienda] = useState([
    { value: "SRL" },
    { value: "SRL Unipersonali" },
    { value: "SPA" },
    { value: "Cooperative" },
    { value: "Associazioni" },
    { value: "Ditte individuali" },
  ]);
  const [CodiceIdent, setCodiceIdent] = useState([
    { value: "Regione" },
    { value: "SDI" },
    { value: "PEC" },
    { value: "Amministratore (cliente)" },
  ]);
  const [Gruppi, setGruppi] = useState([]);
  const [gestioneGruppiAperta, setGestioneGruppiAperta] = useState(false);
  const [nomeGruppo, setNomeGruppo] = useState("");
  const [gruppoInModifica, setGruppoInModifica] = useState(null);
  const [erroreGruppi, setErroreGruppi] = useState("");
  const [salvataggioGruppi, setSalvataggioGruppi] = useState(false);
  const [gruppoEspanso, setGruppoEspanso] = useState(null);
  const [clientiGruppo, setClientiGruppo] = useState([]);
  const [caricamentoClientiGruppo, setCaricamentoClientiGruppo] =
    useState(false);
  const richiestaClientiGruppo = useRef(0);
  const mostraClientiGruppo = async (gruppo) => {
    const richiesta = ++richiestaClientiGruppo.current;
    if (gruppoEspanso === gruppo.id) {
      setGruppoEspanso(null);
      setCaricamentoClientiGruppo(false);
      return;
    }
    setGruppoEspanso(gruppo.id);
    setClientiGruppo([]);
    setErroreGruppi("");
    setCaricamentoClientiGruppo(true);
    try {
      const response = await unsplash.get(
        `gruppiClienti/${gruppo.id}/clienti`,
        { headers: { Authorization: `Bearer ${localStorage.getItem("jwt")}` } },
      );
      if (richiesta === richiestaClientiGruppo.current)
        setClientiGruppo(response.data.data);
    } catch (error) {
      if (richiesta === richiestaClientiGruppo.current)
        setErroreGruppi("Impossibile caricare i clienti del gruppo.");
    } finally {
      if (richiesta === richiestaClientiGruppo.current)
        setCaricamentoClientiGruppo(false);
    }
  };
  const adminGruppi = String(sessionStorage.getItem("Autorizzazione")) === "1";
  const caricaGruppi = async () => {
    try {
      const response = await unsplash.get("gruppiClienti", {
        headers: { Authorization: `Bearer ${localStorage.getItem("jwt")}` },
      });
      setGruppi(
        response.data.data.map((g) => ({ id: g.ID, value: g.Descrizione })),
      );
      setErroreGruppi("");
    } catch (error) {
      setErroreGruppi("Impossibile caricare i gruppi.");
    }
  };
  useEffect(() => {
    caricaGruppi();
  }, []);
  const salvaGruppo = async () => {
    if (!nomeGruppo.trim()) return;
    setSalvataggioGruppi(true);
    try {
      const headers = {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      };
      if (gruppoInModifica) {
        await unsplash.put(
          `gruppiClienti/${gruppoInModifica.id}`,
          { nome: nomeGruppo },
          { headers },
        );
        if (cliente.Gruppo === gruppoInModifica.value)
          setCliente((current) => ({ ...current, Gruppo: nomeGruppo.trim() }));
      } else
        await unsplash.post("gruppiClienti", { nome: nomeGruppo }, { headers });
      setNomeGruppo("");
      setGruppoInModifica(null);
      await caricaGruppi();
    } catch (error) {
      setErroreGruppi(
        error.response?.data?.message || "Impossibile salvare il gruppo.",
      );
    } finally {
      setSalvataggioGruppi(false);
    }
  };
  const [lavoratoriCorsiInScadenza, setLavoratoriCorsiInScadenza] = useState(
    [],
  );
  const [loading, setLoading] = useState(true);
  const [analysis, setAnalysis] = useState({
    totale: 0,
    formati: 0,
    nonFormati: 0,
    percentualeFormati: 0,
    percentualeNonFormati: 0,
  });
  const [loadingA, setLoadingA] = useState(true);

  const [analysisMedicina, setAnalysisMedicina] = useState({
    totale: 0,
    visitati: 0,
    nonVisitati: 0,
    percentualeVisitati: 0,
    percentualeNonVisitati: 0,
  });
  const [loadingM, setLoadingM] = useState(true);
  const [adempimentiScaduti, setAdempimentiScaduti] = useState([]);
  const [loadingScad, setLoadingScad] = useState(true);

  const navigate = useNavigate();
  const [openSnack, setOpenSnack] = useState(false);
  const [openRemovePayrollContact, setOpenRemovePayrollContact] =
    useState(false);
  const [removingPayrollContact, setRemovingPayrollContact] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const openInfo = Boolean(anchorEl);

  const handNew = useRef(null);
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [snack, setSnack] = useState({
    severity: "success",
    messaggio: "Salvataggio Effettuato correttamente",
    open: false,
  });
  const columnsMemo = [
    {
      filterable: false,
      field: "Actions",
      headerName: "Info",
      width: 50,
      hide: false,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => (
        <>
          <Info
            sx={{ color: "#2265B1", width: "30px", height: "30px" }}
            onClick={(event) => setAnchorEl(event.currentTarget)}
          />
          <Popover
            open={openInfo}
            onClose={handleClose}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
          >
            <Typography sx={{ p: 2, maxWidth: "400px" }}>
              <b> {params.row.Utente + ": "}</b> <br />
              {params.row.Nota}
            </Typography>
          </Popover>
        </>
      ),
    },
    {
      field: "Data",
      headerName: "Data",
      width: 100,
      align: "center",
      headerAlign: "center",
      renderCell: (
        params, //mi aiuta a mettere il valore
      ) => (
        <>
          {params.row.Data ? moment(params.row.Data).format("DD/MM/YYYY") : ""}
        </>
      ),
    },
    {
      field: "Nota",
      headerName: "Nota",
      flex: 1,
      align: "center",
      headerAlign: "center",
    },
  ];
  const columnSicurezzaLavoratoriCorsiInScadenza = [
    {
      field: "Cognome",
      headerName: "Cognome",
      //width: 400,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "Nome",
      headerName: "Nome",
      //width: 300,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
    {
      field: "*",
      headerName: "Corsi",
      //width: 300,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
      renderCell: (params) => {
        if (params.row.BaseOK === 1) {
          return (
            <div>
              <Tooltip
                title={
                  "Scaduto il " +
                  moment(params.row.Scadenza).format("DD/MM/YYYY")
                }
              >
                <Chip
                  label={params.row.Ruolo}
                  size="small"
                  sx={{
                    width: "70px",
                    marginLeft: "2px",
                    backgroundColor: "#FF2768",
                    color: "white",
                  }}
                />
              </Tooltip>
            </div>
          );
        } else {
          return (
            <div>
              <Tooltip title={"Corso base mancante"}>
                <Chip
                  label={params.row.Ruolo}
                  size="small"
                  sx={{
                    width: "70px",
                    marginLeft: "2px",
                    backgroundColor: "#2265B1",
                    color: "white",
                  }}
                />
              </Tooltip>
            </div>
          );
        }
      },
    },
    {
      field: "Scadenza",
      headerName: "Scadenza",
      //width: 300,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
      renderCell: (params) => {
        return (
          <div>
            {params.row.Scadenza
              ? moment(params.row.Scadenza).format("DD - MM - YYYY")
              : ""}
          </div>
        );
      },
    },
    {
      field: "DescrizioneCorso",
      headerName: "Descrizione",
      //width: 400,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sort: "asc",
    },
  ];
  const columnsAdempimenti = [
    {
      field: "*",
      headerName: "Stato",
      width: 50,
      renderCell: (params) => {
        return <Error sx={{ color: "#FF2768" }} />;
      },
    },
    { field: "Descrizione", headerName: "Descrizione", flex: 1 },
    { field: "Scadenza", headerName: "Validità", flex: 1 },
    {
      field: "UltimaScadenza",
      headerName: "Data",
      flex: 1,
      renderCell: (params) =>
        params.row.UltimaScadenza
          ? moment(params.row.UltimaScadenza).format("DD/MM/YYYY")
          : "",
    },
  ];

  const columnsNuoviLavoratori = [
    {
      field: "*",
      headerName: "Stato",
      width: 50,
      renderCell: (params) => {
        return <NewReleases sx={{ color: "#51E838" }} />;
      },
    },
    { field: "CF", headerName: "CF", flex: 1 },
    { field: "Nome", headerName: "Nome", flex: 1 },
    { field: "Cognome", headerName: "Cognome", flex: 1 },
  ];

  const handleAncor = () => {
    handNew.current.scrollIntoView({ behavior: "smooth" });
  };

  const columnsLavoratoriScadutioInScadenza = [
    {
      field: "StatoVisita",
      headerName: "Stato",
      width: 20,
      renderCell: (
        params, //mi aiuta a mettere il valore
      ) => (
        <div>
          {params.row.StatoVisita === "OK" ? (
            <CheckCircle sx={{ color: "#40C18F" }} />
          ) : (
            <Error
              sx={{
                color:
                  params.row.StatoVisita === "Scadenza" ||
                  params.row.StatoVisita === "InScadenza"
                    ? "#FFC897"
                    : params.row.StatoVisita === "Parziale"
                      ? "#2265B1"
                      : "#FF2768",
              }}
            />
          )}
        </div>
      ),
    },
    { field: "Nome", headerName: "Nome", flex: 1 },
    { field: "Cognome", headerName: "Cognome", flex: 1 },
    { field: "RagioneSociale", headerName: "Cliente", flex: 1 },
    { field: "Scadenza", headerName: "Scadenza", width: 90 },
  ];

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
        >
          <GridToolbarQuickFilter placeholder="Cerca..." />
        </Grid>
      </GridToolbarContainer>
    );
  }

  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
  };
  useEffect(() => {
    if (location?.state || state) {
      try {
        localStorage.setItem(
          detailStateKey,
          JSON.stringify(location.state || state),
        );
      } catch (error) {}
    }
  }, [location?.state]);

  useEffect(() => {
    sessionStorage.setItem("page", "Dettaglio Cliente");
  }, []);

  useEffect(() => {
    if (!state) {
      try {
        const stored = localStorage.getItem(detailStateKey);
        if (stored) {
          const parsed = JSON.parse(stored);
          if (parsed) {
            navigate("/dettaglioCliente", { state: parsed, replace: true });
          }
        }
      } catch (error) {}
    }
  }, [state, navigate]);
  useEffect(() => {
    try {
      const stored = localStorage.getItem(storageKey);
      if (stored !== null && stored !== undefined && stored !== "") {
        const parsed = Number(stored);
        if (!Number.isNaN(parsed)) {
          setValue(parsed);
        }
      }
    } catch (error) {}
  }, [storageKey]);
  useEffect(() => {
    if (!billingAreas) return;
    const area = { 7: "Medicina", 8: "Sicurezza", 9: "Formazione" }[value];
    if (area && !billingAreas[area]) {
      setValue(0);
      localStorage.setItem(storageKey, "0");
    }
  }, [billingAreas, value, storageKey]);
  useEffect(() => {
    if (!extraAccess || !cliente.ID) return;
    const financialTab = cliente.Gruppo === "Gavio" ? 15 : 14;
    if (value === financialTab && !extraAccess.canFatturazione) {
      setValue(0);
      localStorage.setItem(storageKey, "0");
    }
  }, [extraAccess, cliente.ID, cliente.Gruppo, value, storageKey]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
    try {
      localStorage.setItem(storageKey, String(newValue));
    } catch (error) {}
  };
  const handleInputChange = (e) => {
    let copiaCliente = { ...cliente };
    copiaCliente[e.target.name] = e.target.value;

    setCliente(copiaCliente);
  };

  const handleCboxChange = (e) => {
    let copiaCliente = { ...cliente };
    if (e.target.name === "GestioneMedicina") {
      copiaCliente[e.target.name] = e.target.checked ? 1 : 0;

      copiaCliente["InvioSollMedico"] = e.target.checked ? 1 : 0;
      copiaCliente["FatturaVisiteMediche"] = e.target.checked ? 1 : 0;
    } else {
      copiaCliente[e.target.name] = e.target.checked ? 1 : 0;
    }

    setCliente(copiaCliente);
  };

  const getBase64 = (file) => {
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {};
    reader.onerror = function (error) {
      console.log("Error: ", error);
    };
  };

  const handleChangeImage = async (e) => {
    const file = e.target.files[0]; // prendo la foto caricata sempre nell'evento
    if (!file) {
      return;
    }

    try {
      const resizedLogo = await resizeImageForStorage(file);
      document.getElementById("Logo").src = resizedLogo.dataUrl;
      cliente.Logo = resizedLogo.base64;
    } catch (error) {
      console.error(error);
    }
  };
  //save data
  const saveData = async () => {
    try {
      await unsplash
        .post(
          "updateClienti",
          { cliente, ragioneSocialeOriginale: oldCliente?.RagioneSociale },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          },
        )
        .then((res) => {});

      await unsplash
        .post(
          "storico",
          {
            tabella: "Clienti",
            key: cliente.ID,
            utente: sessionStorage.getItem("username"),
            after: cliente,
            before: oldCliente,
            operazione: "Modifica",
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          },
        )
        .then((res) => {});
      setSnack({
        severity: "success",
        messaggio: "Cliente salvato con successo",
      });
      setOpenSnack(true);
      setOldCliente(cliente);
    } catch (error) {
      setSnack({
        severity: "error",
        messaggio:
          error.response?.data?.message || "Errore durante il salvataggio",
      });
      setOpenSnack(true);
    }
  };

  const removePayrollContact = async () => {
    setRemovingPayrollContact(true);
    const previousClient = { ...cliente };
    try {
      await unsplash.post(
        "updateClienti",
        {
          operazione: "RimuoviReferentePaghe",
          clienteId: cliente.ID,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        },
      );

      const updatedClient = { ...cliente, NomeReferente: null };
      setCliente(updatedClient);
      setOldCliente(updatedClient);
      setOpenRemovePayrollContact(false);
      setSnack({
        severity: "success",
        messaggio: "Referente paghe rimosso con successo",
      });
      setOpenSnack(true);

      try {
        await unsplash.post(
          "storico",
          {
            tabella: "Clienti",
            key: cliente.ID,
            utente: sessionStorage.getItem("username"),
            after: updatedClient,
            before: previousClient,
            operazione: "Modifica",
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          },
        );
      } catch (historyError) {
        console.error(
          "Errore salvataggio storico referente paghe",
          historyError,
        );
      }
    } catch (error) {
      setSnack({
        severity: "error",
        messaggio:
          error.response?.data?.message ||
          "Errore durante la rimozione del referente paghe",
      });
      setOpenSnack(true);
    } finally {
      setRemovingPayrollContact(false);
    }
  };

  const handleFile = async () => {
    await unsplash
      .post(
        "ftp",
        { operazione: "download" },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        },
      )
      .then((res) => {
        window.open("http://localhost:3000/file");
      });
  };

  const reloadLavoratori = async () => {
    const responseAziendali = await unsplash.get("lavoratori", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("jwt")}`,
      },
      params: { id: state.idC },
    });

    setLavoratori(responseAziendali.data.data);
    setLoadingLav(false);
    return responseAziendali.data.data;
  };

  useEffect(() => {
    if (!state?.idC) {
      return;
    }
    // è un loop qui carico i dati
    const fetchData = async () => {
      try {
        let response = await unsplash.post(
          "clientDetail",
          { auth: "a5d42c3ed7977afa2d8e922569e7940b", id: state.idC },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          },
        );
        await setCliente(response.data.data[0]);

        setOldCliente(response.data.data[0]);

        let resMemo = await unsplash.get("memo", {
          params: { idMemo: state.idC },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        });

        setLoadingMemo(false);
        setMemoVisibili(resMemo.data.data);

        let resNuoviLav = await unsplash.get("lavoratori/nuovi", {
          params: { cliente: state.idC },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        });

        setNuoviLav(resNuoviLav.data.data);
        setLoadingNuoviLav(false);

        let rescadutiMedicina = await unsplash.get(
          "lavoratori/scaduti-medicina",
          {
            params: { cliente: state.idC },
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          },
        );

        setLavScadutiMedicina(rescadutiMedicina.data.data);
        setLoadingScadutiMedicina(false);

        let responseAziendali = await unsplash.get("lavoratori", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
          params: { id: state.idC },
        });

        setLavoratori(responseAziendali.data.data);

        let responseUtenti = await unsplash.get("utenti", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        });

        const utentiMedicina = responseUtenti.data.data.filter(
          (elm) => elm.tipoUtente === "Medicina",
        );
        const utentiSicurezza = responseUtenti.data.data.filter(
          (elm) =>
            elm.tipoUtente === "Sicurezza" && elm.username !== "federico",
        );
        const utentiFormazione = responseUtenti.data.data.filter(
          (elm) => elm.tipoUtente === "Formazione",
        );
        setUtenti(utentiMedicina);
        setUtentiSicurezza(utentiSicurezza);
        setUtentiFormazione(utentiFormazione);

        let responseAnalysis = await unsplash.get("analysis", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
          params: {
            cliente: state.idC,
            operazione: "sicurezzaPercentualiCliente",
          },
        });

        setAnalysis(responseAnalysis.data.data);
        setLoadingA(false);

        let responseAdempimenti = await unsplash.get("analysis", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
          params: {
            ID: state.idC,
            operazione: "scadenzeAdempimentiClienti",
          },
        });

        setAdempimentiScaduti(responseAdempimenti.data.data);
        setLoadingScad(false);

        let responseAnalysisCliente = await unsplash.get("analysis", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
          params: {
            cliente: state.idC,
            operazione: "sicurezzaLavoratoriCorsiInScadenzaCliente",
          },
        });

        setLavoratoriCorsiInScadenza(responseAnalysisCliente.data.data);
        setLoading(false);

        let responseAnalysisMedicina = await unsplash.get("analysis", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
          params: {
            cliente: state.idC,
            operazione: "medicinaPercentualiCliente",
          },
        });

        setAnalysisMedicina(responseAnalysisMedicina.data.data);
        setLoadingM(false);

        const logo = document.getElementById("logo");

        if (logo) {
          setLogo(logo.src);
        }

        let responseUsr = await unsplash.get("utenti", {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("jwt")}`,
          },
        });

        const user = responseUsr.data.data.filter(
          (utente) => sessionStorage.getItem("username") === utente.username,
        );
        setUser(user[0]);

        setLoadingScad(false);
        setLoadingNuov(false);
        setLoadingVis(false);
      } catch (error) {
        console.error(error.message);
      }
    };

    fetchData();
  }, [state?.idC]);

  return (
    <>
      <GlobalSnackbar
        severity={snack.severity}
        messaggio={snack.messaggio}
        openSnack={openSnack}
        handleCloseSnack={handleCloseSnack}
      />
      <Dialog
        open={openRemovePayrollContact}
        onClose={() =>
          !removingPayrollContact && setOpenRemovePayrollContact(false)
        }
      >
        <DialogTitle>Rimuovere il referente paghe?</DialogTitle>
        <DialogContent>
          <Typography>
            Il referente paghe verrà rimosso da {cliente.RagioneSociale}. Potrà
            essere reinserito dal prossimo aggiornamento automatico.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => setOpenRemovePayrollContact(false)}
            disabled={removingPayrollContact}
          >
            Annulla
          </Button>
          <Button
            color="error"
            variant="contained"
            onClick={removePayrollContact}
            disabled={removingPayrollContact}
            startIcon={
              removingPayrollContact ? (
                <CircularProgress size={16} color="inherit" />
              ) : (
                <DeleteOutline />
              )
            }
          >
            Rimuovi
          </Button>
        </DialogActions>
      </Dialog>
      <Grid item xs={12}>
        <Card sx={{ position: "relative", my: "auto" }}>
          <CardHeader
            sx={{ textAlign: "center" }}
            title={ragioneSociale}
            titleTypographyProps={{ variant: "h4" }}
          />
        </Card>

        <Card sx={{ marginTop: "10px" }}>
          <CardContent sx={{ p: 0 }}>
            <Box sx={{ width: "100%" }}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  aria-label="basic tabs example"
                  variant="scrollable"
                >
                  <Tab
                    icon={<DashboardIcon />}
                    iconPosition="start"
                    label="Dashboard"
                    value={0}
                  />
                  <Tab
                    icon={<Home />}
                    iconPosition="start"
                    label="Sedi"
                    value={1}
                  />
                  <Tab
                    icon={<Work />}
                    iconPosition="start"
                    label="Dati Aziendali"
                    value={2}
                  />
                  <Tab
                    icon={<AccountCircle />}
                    iconPosition="start"
                    label="Lavoratori"
                    value={3}
                  />
                  <Tab
                    icon={<AttachFile />}
                    iconPosition="start"
                    label="Allegati"
                    value={4}
                    style={{
                      display:
                        user.Formazione && !user.Medicina && !user.Sicurezza
                          ? "none"
                          : "",
                    }}
                  />

                  <Tab
                    icon={<MedicalServices />}
                    iconPosition="start"
                    label="Medici"
                    value={5}
                    style={{
                      display:
                        user.Formazione && !user.Medicina && !user.Sicurezza
                          ? "none"
                          : "",
                    }}
                  />

                  <Tab
                    icon={<Engineering />}
                    iconPosition="start"
                    label="Mansioni medicina"
                    value={6}
                    style={{
                      display:
                        user.Formazione && !user.Medicina && !user.Sicurezza
                          ? "none"
                          : "",
                    }}
                  />

                  <Tab
                    icon={<Euro />}
                    iconPosition="start"
                    label="Fatt. Medicina"
                    value={7}
                    style={{ display: billingAreas?.Medicina ? "" : "none" }}
                  />

                  <Tab
                    icon={<Euro />}
                    iconPosition="start"
                    label="Fatt. Consulenza"
                    value={8}
                    style={{ display: billingAreas?.Sicurezza ? "" : "none" }}
                  />
                  <Tab
                    icon={<School />}
                    iconPosition="start"
                    label="Fatt. Formazione"
                    value={9}
                    style={{ display: billingAreas?.Formazione ? "" : "none" }}
                  />
                  <Tab
                    icon={<Euro />}
                    iconPosition="start"
                    label="Fatt. Extra"
                    value={cliente?.Gruppo === "Gavio" ? 15 : 14}
                    style={{
                      display: Object.values(extraAccess?.aree || {}).some(
                        Boolean,
                      )
                        ? ""
                        : "none",
                    }}
                  />
                  <Tab
                    icon={<LocationOn />}
                    iconPosition="start"
                    label="Sopralluoghi"
                    value={10}
                  />
                  {cliente?.Gruppo === "Gavio" && (
                    <Tab
                      icon={<TimeToLeave />}
                      iconPosition="start"
                      label="EXTRA MEDICI"
                      value={11}
                      style={{ display: billingAreas?.Medicina ? "" : "none" }}
                    />
                  )}
                  <Tab
                    icon={<SpeakerNotesRoundedIcon />}
                    iconPosition="start"
                    label="Memo"
                    value={cliente?.Gruppo === "Gavio" ? 12 : 11}
                  />
                  <Tab
                    icon={<LocationOn />}
                    iconPosition="start"
                    label="Uscite tecnici"
                    value={cliente?.Gruppo === "Gavio" ? 13 : 12}
                    style={{ display: billingAreas?.Sicurezza ? "" : "none" }}
                  />
                  <Tab
                    icon={<Euro />}
                    iconPosition="start"
                    label="Extra"
                    value={cliente?.Gruppo === "Gavio" ? 14 : 13}
                  />
                </Tabs>
              </Box>
              <TabPanel
                value={value}
                index={0}
                style={{
                  marginTop: "5px",
                  backgroundColor: "#11526F",
                  borderRadius: "5px",
                }}
              >
                {analysis.length === 0 ? (
                  <div>
                    <center>
                      <CircularProgress color="primary" />
                    </center>
                  </div>
                ) : (
                  <>
                    <Grid container spacing={2}>
                      {!loadingNuoviLav & (nuoviLav.length > 0) ? (
                        <Grid xs={12} item>
                          <Button
                            className="Button"
                            sx={{ color: "white" }}
                            startIcon={
                              <NewReleases className="animated-icon-green" />
                            }
                            variant="text"
                            onClick={handleAncor}
                          >
                            Presenti Nuovi Lavoratori
                          </Button>
                        </Grid>
                      ) : (
                        ""
                      )}
                      {/* Formazione Lavoratori*/}
                      <Grid xs={12} md={6} item>
                        <Card sx={{ boxShadow: "none" }}>
                          <CardHeader title="Andamento formazione" />

                          <CardContent>
                            <Grid container spacing={1}>
                              <Grid
                                xs={12}
                                lg={4}
                                item
                                sx={{ my: "auto", padding: 0 }}
                              >
                                <div className="flex items-center justify-center h-full">
                                  {analysis.percentualeFormati ? (
                                    <CircularProgressWithLabel
                                      variant="determinate"
                                      value={analysis.percentualeFormati}
                                      size={150}
                                    />
                                  ) : (
                                    <CircularProgress
                                      size={80}
                                      thickness={5}
                                      sx={{ color: "#2265B1" }}
                                    />
                                  )}
                                </div>
                              </Grid>
                              <Grid xs={12} lg={8} item>
                                <div className="flex flex-no-wrap items-center">
                                  <PercentIcon
                                    sx={{ fontSize: 55, color: "#11526F" }}
                                  />
                                  <div
                                    style={{ marginLeft: "5px" }}
                                    className="flex flex-wrap"
                                  >
                                    <span
                                      className="w-full fw-light fs-6"
                                      style={{
                                        color: "rgba(58, 53, 65, 0.6)",
                                      }}
                                    >
                                      Lavoratori formati
                                    </span>
                                    <h6
                                      className="fs-5 fw-bold"
                                      style={{ color: "#11526F" }}
                                    >
                                      {analysis.percentualeFormati}
                                    </h6>
                                  </div>
                                </div>
                                <Divider
                                  sx={{ color: "rgba(58, 53, 65, 0.6)" }}
                                />
                                <div
                                  className="flex flex-wrap  "
                                  style={{ padding: "15px 0" }}
                                >
                                  <div className="w-full flex flex-wrap items-center">
                                    <Avatar
                                      sx={{
                                        fontSize: 40,
                                        background: "#2265B1",
                                      }}
                                    >
                                      <People></People>
                                    </Avatar>
                                    <div
                                      style={{ marginLeft: "5px" }}
                                      className="flex flex-wrap"
                                    >
                                      <span
                                        style={{
                                          float: "left",
                                          marginRight: "5px",
                                          width: "100%",
                                          color: "rgba(58, 53, 65, 0.6)",
                                        }}
                                      >
                                        {" Totale corsisti"}
                                      </span>
                                      <span
                                        className="fs-6 fw-semibold"
                                        style={{ color: "#11526F" }}
                                      >
                                        {analysis.totale}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="w-full flex flex-wrap items-center">
                                    <Avatar
                                      sx={{
                                        fontSize: 40,
                                        background: "#40C18F",
                                      }}
                                    >
                                      <People></People>
                                    </Avatar>
                                    <div
                                      style={{ marginLeft: "5px" }}
                                      className="flex flex-wrap"
                                    >
                                      <span
                                        style={{
                                          float: "left",
                                          marginRight: "5px",
                                          width: "100%",
                                          color: "rgba(58, 53, 65, 0.6)",
                                        }}
                                      >
                                        {" Formazione completa"}
                                      </span>
                                      <span
                                        className="fs-6 fw-semibold"
                                        style={{ color: "#11526F" }}
                                      >
                                        {analysis.formati}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="w-full flex flex-wrap items-center">
                                    <Avatar
                                      sx={{
                                        fontSize: 40,
                                        background: "#FF2768",
                                      }}
                                    >
                                      <People></People>
                                    </Avatar>
                                    <div
                                      style={{ marginLeft: "5px" }}
                                      className="flex flex-wrap"
                                    >
                                      <span
                                        style={{
                                          float: "left",
                                          marginRight: "5px",
                                          width: "100%",
                                          color: "rgba(58, 53, 65, 0.6)",
                                        }}
                                      >
                                        {" Formazione incompleta"}
                                      </span>
                                      <span
                                        className="fs-6 fw-semibold"
                                        style={{ color: "#11526F" }}
                                      >
                                        {analysis.nonFormati}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                      {/* Formazione Visite */}{" "}
                      <Grid xs={12} md={6} item>
                        <Card sx={{ boxShadow: "none" }}>
                          <CardHeader title="Andamento sorveglianza" />

                          <CardContent>
                            <Grid container spacing={1}>
                              <Grid
                                xs={12}
                                lg={4}
                                item
                                sx={{ my: "auto", padding: 0 }}
                              >
                                <div className="flex items-center justify-center h-full">
                                  {analysisMedicina.percentualeVisitati ? (
                                    <CircularProgressWithLabel
                                      variant="determinate"
                                      value={
                                        analysisMedicina.percentualeVisitati
                                      }
                                      size={150}
                                    />
                                  ) : (
                                    <CircularProgress
                                      size={80}
                                      thickness={5}
                                      sx={{ color: "#2265B1" }}
                                    />
                                  )}
                                </div>
                              </Grid>
                              <Grid xs={12} lg={8} item>
                                <div className="flex flex-no-wrap items-center">
                                  <PercentIcon
                                    sx={{ fontSize: 55, color: "#11526F" }}
                                  />
                                  <div
                                    style={{ marginLeft: "5px" }}
                                    className="flex flex-wrap"
                                  >
                                    <span
                                      className="w-full fw-light fs-6"
                                      style={{
                                        color: "rgba(58, 53, 65, 0.6)",
                                      }}
                                    >
                                      Lavoratori sorvegliati
                                    </span>
                                    <h6
                                      className="fs-5 fw-bold"
                                      style={{ color: "#11526F" }}
                                    >
                                      {analysisMedicina.percentualeVisitati}
                                    </h6>
                                  </div>
                                </div>
                                <Divider
                                  sx={{ color: "rgba(58, 53, 65, 0.6)" }}
                                />
                                <div
                                  className="flex flex-wrap  "
                                  style={{ padding: "15px 0" }}
                                >
                                  <div className="w-full flex flex-wrap items-center">
                                    <Avatar
                                      sx={{
                                        fontSize: 40,
                                        background: "#2265B1",
                                      }}
                                    >
                                      <People></People>
                                    </Avatar>
                                    <div
                                      style={{ marginLeft: "5px" }}
                                      className="flex flex-wrap"
                                    >
                                      <span
                                        style={{
                                          float: "left",
                                          marginRight: "5px",
                                          width: "100%",
                                          color: "rgba(58, 53, 65, 0.6)",
                                        }}
                                      >
                                        {" Totale sorvegliati"}
                                      </span>
                                      <span
                                        className="fs-6 fw-semibold"
                                        style={{ color: "#11526F" }}
                                      >
                                        {analysisMedicina.totale}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="w-full flex flex-wrap items-center">
                                    <Avatar
                                      sx={{
                                        fontSize: 40,
                                        background: "#40C18F",
                                      }}
                                    >
                                      <People></People>
                                    </Avatar>
                                    <div
                                      style={{ marginLeft: "5px" }}
                                      className="flex flex-wrap"
                                    >
                                      <span
                                        style={{
                                          float: "left",
                                          marginRight: "5px",
                                          width: "100%",
                                          color: "rgba(58, 53, 65, 0.6)",
                                        }}
                                      >
                                        {" Sorveglianza completa"}
                                      </span>
                                      <span
                                        className="fs-6 fw-semibold"
                                        style={{ color: "#11526F" }}
                                      >
                                        {analysisMedicina.visitati}
                                      </span>
                                    </div>
                                  </div>
                                  <div className="w-full flex flex-wrap items-center">
                                    <Avatar
                                      sx={{
                                        fontSize: 40,
                                        background: "#FF2768",
                                      }}
                                    >
                                      <People></People>
                                    </Avatar>
                                    <div
                                      style={{ marginLeft: "5px" }}
                                      className="flex flex-wrap"
                                    >
                                      <span
                                        style={{
                                          float: "left",
                                          marginRight: "5px",
                                          width: "100%",
                                          color: "rgba(58, 53, 65, 0.6)",
                                        }}
                                      >
                                        {" Sorveglianza incompleta"}
                                      </span>
                                      <span
                                        className="fs-6 fw-semibold"
                                        style={{ color: "#11526F" }}
                                      >
                                        {analysisMedicina.nonVisitati}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                      {/* Corsi Scaduti */}{" "}
                      <Grid item xs={12} md={6}>
                        <Card sx={{ boxShadow: "none" }}>
                          <CardHeader title="Corsi Scaduti" />

                          <CardContent>
                            <Box
                              sx={{
                                height: 300,
                                width: 1,
                              }}
                            >
                              <DataGridPro
                                initialState={{
                                  pinnedColumns: { left: ["Actions"] },
                                }}
                                sx={{ fontSize: 12 }}
                                components={{
                                  Toolbar: CustomToolbar,
                                  Footer: CustomFooterPersonalized,
                                }}
                                slots={{
                                  loadingOverlay: LinearProgress,
                                }}
                                loading={loading}
                                localeText={
                                  itIT.components.MuiDataGrid.defaultProps
                                    .localeText
                                }
                                rows={lavoratoriCorsiInScadenza}
                                columns={
                                  columnSicurezzaLavoratoriCorsiInScadenza
                                }
                                getRowId={(row) =>
                                  row.Lavoratore + "-" + row.Ruolo
                                }
                                pageSize={100}
                                disableSelectionOnClick
                              />
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Card sx={{ boxShadow: "none" }}>
                          <CardHeader title="Adempimenti Scaduti" />

                          <CardContent>
                            <Box
                              sx={{
                                height: 300,
                                width: 1,
                              }}
                            >
                              <DataGridPro
                                sx={{ fontSize: 12 }}
                                components={{
                                  Toolbar: CustomToolbar,
                                  Footer: CustomFooterPersonalized,
                                }}
                                localeText={
                                  itIT.components.MuiDataGrid.defaultProps
                                    .localeText
                                }
                                slots={{
                                  loadingOverlay: LinearProgress,
                                }}
                                loading={loadingScad}
                                rows={adempimentiScaduti}
                                columns={columnsAdempimenti}
                                getRowId={(row) => row.ID}
                                pageSize={100}
                                disableSelectionOnClick
                                initialState={{
                                  pinnedColumns: { left: ["*"] },
                                }}
                              />
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                      {/* Visite scadute */}
                      <Grid item xs={12} md={6}>
                        <Card sx={{ boxShadow: "none" }}>
                          <CardHeader title="Visite Scadute" />
                          <CardContent>
                            <Box
                              sx={{
                                height: 300,
                                width: 1,
                              }}
                            >
                              <DataGridPro
                                initialState={{
                                  pinnedColumns: { left: ["Actions"] },
                                }}
                                sx={{ fontSize: 12 }}
                                components={{
                                  Toolbar: CustomToolbar,
                                  Footer: CustomFooterPersonalized,
                                }}
                                slots={{
                                  loadingOverlay: LinearProgress,
                                }}
                                loading={loadingScadutiMedicina}
                                localeText={
                                  itIT.components.MuiDataGrid.defaultProps
                                    .localeText
                                }
                                rows={lavoratoriScadutiMedicina}
                                columns={columnsLavoratoriScadutioInScadenza}
                                getRowId={(row) => row.ID}
                                pageSize={100}
                                disableSelectionOnClick
                              />
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Card sx={{ boxShadow: "none" }}>
                          <CardHeader title="Nuovi Lavoratori" />

                          <CardContent>
                            <Box
                              sx={{
                                height: 300,
                                width: 1,
                              }}
                            >
                              <DataGridPro
                                sx={{ fontSize: 12 }}
                                components={{
                                  Toolbar: CustomToolbar,
                                  Footer: CustomFooterPersonalized,
                                }}
                                localeText={
                                  itIT.components.MuiDataGrid.defaultProps
                                    .localeText
                                }
                                slots={{
                                  loadingOverlay: LinearProgress,
                                }}
                                loading={loadingNuoviLav}
                                rows={nuoviLav}
                                columns={columnsNuoviLavoratori}
                                ref={handNew}
                                getRowId={(row) => row.ID}
                                pageSize={100}
                                disableSelectionOnClick
                                initialState={{
                                  pinnedColumns: { left: ["*"] },
                                }}
                              />
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                      {/* Memo e Fatturazione */}{" "}
                      <Grid item xs={12} md={12}>
                        <Card sx={{ boxShadow: "none" }}>
                          <CardHeader title="Memo" />

                          <CardContent>
                            <Box
                              sx={{
                                height: 300,
                                width: 1,
                              }}
                            >
                              <DataGridPro
                                initialState={{
                                  pinnedColumns: { left: ["Actions"] },
                                }}
                                sx={{ fontSize: 12 }}
                                components={{
                                  Toolbar: CustomToolbar,
                                  Footer: CustomFooterPersonalized,
                                }}
                                slots={{
                                  loadingOverlay: LinearProgress,
                                }}
                                loading={loadingMemo}
                                localeText={
                                  itIT.components.MuiDataGrid.defaultProps
                                    .localeText
                                }
                                rows={memoVisibili}
                                columns={columnsMemo}
                                getRowId={(row) => row.ID}
                                pageSize={100}
                                disableSelectionOnClick
                              />
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid>
                      {/* <Grid item xs={12} md={6}>
                        <Card sx={{ boxShadow: "none" }}>
                          <CardHeader title="Fatturato Cliente" />
                          <CardContent
                            sx={{
                              padding: 2,
                            }}
                          >
                            <Box
                              sx={{
                                height: 300,
                                width: 1,
                              }}
                            >
                              <SchedaFatturato />
                            </Box>
                          </CardContent>
                        </Card>
                      </Grid> */}
                    </Grid>
                  </>
                )}
              </TabPanel>
              <TabPanel value={value} index={1}>
                <Sedi
                  screenSize={props.screenSize}
                  idAzienda={clienteId}
                  infoSede={cliente}
                  ragioneSociale={ragioneSociale}
                  sedeLoc={cliente.SedeLocalita}
                  sedeInd={cliente.SedeIndirizzo}
                  sedeCap={cliente.SedeCAP}
                  logo={
                    cliente.Logo !== ""
                      ? getImageDataUrl(cliente.Logo)
                      : require("../assets/images/MILLERLogo.jpg")
                  }
                />
              </TabPanel>
              <TabPanel
                value={value}
                index={2}
                style={{
                  marginTop: "5px",
                  backgroundColor: "#11526F",
                  borderRadius: "5px",
                }}
              >
                <Box
                  sx={{
                    backgroundColor: "#ffffff",
                    borderRadius: "5px",
                    p: 2,
                  }}
                >
                  <Card>
                    {/* Image Container*/}
                    <Grid container>
                      <Grid item xs={12} md={6} p={2}>
                        <Box
                          sx={{
                            alignContent: "center",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <CardActionArea
                            onClick={() => {
                              document.getElementById("file").click();
                            }}
                          >
                            <CardMedia
                              component="img"
                              image={
                                cliente.Logo !== ""
                                  ? getImageDataUrl(cliente.Logo)
                                  : require("../assets/images/MILLERLogo.jpg")
                              }
                              src={
                                cliente.Logo !== ""
                                  ? getImageDataUrl(cliente.Logo)
                                  : require("../assets/images/MILLERLogo.jpg")
                              }
                              id="Logo"
                              alt="img"
                              sx={{
                                height: "150px",
                                objectFit: "contain",
                                display: "flex",
                              }}
                            />
                          </CardActionArea>
                        </Box>
                        <Box sx={{ alignItems: "flex-end" }}>
                          <Button
                            fullWidth
                            className="ButtonMiller"
                            startIcon={<Upload />}
                            variant="contained"
                            onClick={() => {
                              document.getElementById("file").click();
                            }}
                          >
                            Carica Logo
                          </Button>
                        </Box>
                        <input
                          type="file"
                          id="file"
                          accept="image/*"
                          onChange={(e) => handleChangeImage(e)}
                          style={{ display: "none" }}
                        />
                      </Grid>
                      {/* Right Top Container */}

                      <Grid
                        item
                        xs={12}
                        container
                        md={6}
                        p={0}
                        sx={{ mt: { xs: 2, md: 1 }, pl: 0.5 }}
                      >
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            Utente Sicurezza
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={
                              utentiSicurezza?.some(
                                (u) => u.ID === cliente.UtenteSicurezza,
                              )
                                ? cliente.UtenteSicurezza
                                : ""
                            }
                            label="Utente Sicurezza"
                            onChange={(e) => {
                              let c = { ...cliente };
                              c.UtenteSicurezza = e.target.value;
                              setCliente(c);
                            }}
                          >
                            <MenuItem value="">Seleziona...</MenuItem>
                            {utentiSicurezza?.map((u) => (
                              <MenuItem key={u.ID} value={u.ID}>
                                {u.username}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            Utente Medicina
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={
                              utenti?.some(
                                (u) => u.ID === cliente.UtenteAssociato,
                              )
                                ? cliente.UtenteAssociato
                                : ""
                            }
                            label="Utente Associato"
                            onChange={(e) => {
                              let c = { ...cliente };
                              c.UtenteAssociato = e.target.value;
                              setCliente(c);
                            }}
                          >
                            <MenuItem value="">Seleziona...</MenuItem>
                            {utenti?.map((u) => (
                              <MenuItem key={u.ID} value={u.ID}>
                                {u.username}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <FormControl fullWidth>
                          <InputLabel id="demo-simple-select-label">
                            Utente Formazione
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={
                              utentiFormazione?.some(
                                (u) => u.ID === cliente.UtenteFormazione,
                              )
                                ? cliente.UtenteFormazione
                                : ""
                            }
                            label="Utente Formazione"
                            onChange={(e) => {
                              let c = { ...cliente };
                              c.UtenteFormazione = e.target.value;
                              setCliente(c);
                            }}
                          >
                            <MenuItem value="">Seleziona...</MenuItem>
                            {utentiFormazione?.map((u) => (
                              <MenuItem key={u.ID} value={u.ID}>
                                {u.username}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                      </Grid>
                    </Grid>

                    <hr
                      style={{
                        height: "2px",
                        marginTop: "5px",
                        marginBottom: "15px",
                        width: "100%",
                      }}
                    />

                    <Grid
                      container
                      sx={{
                        p: 0,
                        display: "flex",
                        columnGap: "10px",
                        flexWrap: { xs: "wrap", md: "nowrap" },
                        mt: 1,
                      }}
                    >
                      <Grid xs={12} item md={6} sx={{ mt: { xs: 1, md: 0 } }}>
                        <TextField
                          id="standard-basic"
                          fullWidth
                          onChange={(e) => handleInputChange(e)}
                          name="RagioneSociale"
                          label="Ragione Sociale"
                          defaultValue={cliente.RagioneSociale}
                        />
                      </Grid>
                      <Grid
                        item
                        container
                        xs={12}
                        md={6}
                        sx={{
                          p: 0,
                          display: "flex",
                          columnGap: "10px",
                          flexWrap: { xs: "wrap", md: "nowrap" },
                        }}
                      >
                        <Grid xs={12} item md={6} sx={{ mt: { xs: 1, md: 0 } }}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              Tipologia Azienda
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={cliente.TipologiaAzienda ?? ""}
                              label="Tipologia Azienda"
                              onChange={(e) => {
                                let c = { ...cliente };
                                c.TipologiaAzienda = e.target.value;
                                setCliente(c);
                              }}
                            >
                              <MenuItem value="">Seleziona...</MenuItem>
                              {TipologiaAzienda?.map((u) => (
                                <MenuItem key={u.value} value={u.value}>
                                  {u.value}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid xs={12} item md={6} sx={{ mt: { xs: 1, md: 0 } }}>
                          <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">
                              Codice Identificativo
                            </InputLabel>
                            <Select
                              labelId="demo-simple-select-label"
                              id="demo-simple-select"
                              value={cliente.CodiceIdent ?? ""}
                              label="Codice Identificativo"
                              onChange={(e) => {
                                let c = { ...cliente };
                                c.CodiceIdent = e.target.value;
                                setCliente(c);
                              }}
                            >
                              <MenuItem value="">Seleziona...</MenuItem>
                              {CodiceIdent?.map((u) => (
                                <MenuItem key={u.value} value={u.value}>
                                  {u.value}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                        </Grid>
                        <Grid xs={12} item md={6} sx={{ mt: { xs: 1, md: 0 } }}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            <FormControl fullWidth>
                              <InputLabel id="cliente-gruppo-label">
                                Gruppo
                              </InputLabel>
                              <Select
                                labelId="cliente-gruppo-label"
                                id="cliente-gruppo-select"
                                value={cliente.Gruppo ?? ""}
                                label="Gruppo"
                                onChange={(e) => {
                                  let c = { ...cliente };
                                  c.Gruppo = e.target.value || null;
                                  setCliente(c);
                                }}
                              >
                                <MenuItem value="">Nessuno</MenuItem>
                                {Gruppi.map((g) => (
                                  <MenuItem key={g.value} value={g.value}>
                                    {g.value}
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                            <Tooltip title="Gestisci gruppi">
                              <IconButton
                                aria-label="Gestisci gruppi"
                                onClick={() => setGestioneGruppiAperta(true)}
                                sx={{
                                  border: "1px solid #0f4761",
                                  borderRadius: 1,
                                  color: "#0f4761",
                                }}
                              >
                                <Add />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </Grid>
                      </Grid>
                    </Grid>
                    {/* Prima Riga */}
                    <Dialog
                      open={gestioneGruppiAperta}
                      onClose={() => setGestioneGruppiAperta(false)}
                      fullWidth
                      maxWidth="sm"
                      PaperProps={{ sx: { maxHeight: "min(680px, 85vh)" } }}
                    >
                      <DialogTitle
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          color: "#0f4761",
                          fontWeight: 600,
                        }}
                      >
                        Gestione gruppi
                        <IconButton
                          aria-label="Chiudi"
                          onClick={() => setGestioneGruppiAperta(false)}
                        >
                          <Close />
                        </IconButton>
                      </DialogTitle>
                      <DialogContent dividers>
                        <Typography
                          variant="body2"
                          color="text.secondary"
                          sx={{ mb: 2 }}
                        >
                          Organizza i gruppi da assegnare alle aziende.
                        </Typography>
                        {erroreGruppi && (
                          <Alert severity="error" sx={{ mb: 2 }}>
                            {erroreGruppi}
                          </Alert>
                        )}
                        {!adminGruppi && (
                          <Alert severity="info" sx={{ mb: 2 }}>
                            Solo gli amministratori possono modificare i gruppi.
                          </Alert>
                        )}
                        <Box sx={{ display: "flex", gap: 1, mb: 3 }}>
                          <TextField
                            fullWidth
                            size="small"
                            label="Nome del gruppo"
                            value={nomeGruppo}
                            onChange={(e) => setNomeGruppo(e.target.value)}
                            disabled={!adminGruppi || salvataggioGruppi}
                          />
                          <Button
                            variant="contained"
                            startIcon={<Add />}
                            disabled={
                              !adminGruppi ||
                              salvataggioGruppi ||
                              !nomeGruppo.trim()
                            }
                            onClick={salvaGruppo}
                          >
                            {gruppoInModifica ? "Salva" : "Aggiungi"}
                          </Button>
                        </Box>
                        {gruppoInModifica && (
                          <Button
                            size="small"
                            onClick={() => {
                              setGruppoInModifica(null);
                              setNomeGruppo("");
                              setErroreGruppi("");
                            }}
                          >
                            Annulla modifica
                          </Button>
                        )}
                        <Typography
                          variant="subtitle2"
                          sx={{ color: "#0f4761", mb: 1 }}
                        >
                          Gruppi disponibili
                        </Typography>
                        {Gruppi.map((gruppo) => (
                          <Box
                            key={gruppo.id}
                            sx={{
                              border: "1px solid #e0e8eb",
                              borderRadius: 1,
                              mb: 1,
                            }}
                          >
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                py: 1,
                                px: 1.5,
                              }}
                            >
                              <Button
                                onClick={() => mostraClientiGruppo(gruppo)}
                                aria-expanded={gruppoEspanso === gruppo.id}
                                sx={{
                                  color: "#0f4761",
                                  textTransform: "none",
                                  justifyContent: "flex-start",
                                  flex: 1,
                                }}
                              >
                                {gruppo.value}
                              </Button>
                              <IconButton
                                aria-label={`Modifica ${gruppo.value}`}
                                disabled={
                                  !adminGruppi ||
                                  salvataggioGruppi ||
                                  ["gavio", "conter"].includes(
                                    gruppo.value.toLowerCase(),
                                  )
                                }
                                onClick={() => {
                                  setGruppoInModifica(gruppo);
                                  setNomeGruppo(gruppo.value);
                                  setErroreGruppi("");
                                }}
                                size="small"
                              >
                                <EditOutlined />
                              </IconButton>
                            </Box>
                            {gruppoEspanso === gruppo.id && (
                              <Box
                                sx={{
                                  borderTop: "1px solid #e0e8eb",
                                  maxHeight: 220,
                                  overflowY: "auto",
                                  px: 2,
                                  py: 1.5,
                                }}
                              >
                                {caricamentoClientiGruppo ? (
                                  <Typography variant="body2">
                                    Caricamento clienti...
                                  </Typography>
                                ) : clientiGruppo.length ? (
                                  clientiGruppo.map((c) => (
                                    <Typography
                                      key={c.ID}
                                      variant="body2"
                                      sx={{ py: 0.5 }}
                                    >
                                      {c.RagioneSociale}
                                      {Number(c.Cessato) === 1
                                        ? " (cessato)"
                                        : ""}
                                    </Typography>
                                  ))
                                ) : (
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                  >
                                    Nessun cliente associato.
                                  </Typography>
                                )}
                              </Box>
                            )}
                          </Box>
                        ))}
                      </DialogContent>
                      <DialogActions>
                        <Button onClick={() => setGestioneGruppiAperta(false)}>
                          Chiudi
                        </Button>
                      </DialogActions>
                    </Dialog>

                    <Grid
                      container
                      sx={{
                        p: 0,
                        display: "flex",
                        columnGap: "10px",
                        flexWrap: { xs: "wrap", md: "nowrap" },
                        mt: 1,
                      }}
                    >
                      <Grid
                        item
                        xs={12}
                        container
                        md={6}
                        sx={{
                          p: 0,
                          display: "flex",
                          columnGap: "10px",
                          flexWrap: { xs: "wrap", md: "nowrap" },
                        }}
                      >
                        <Grid xs={12} item md={6}>
                          <TextField
                            id="standard-basic"
                            fullWidth
                            onChange={(e) => handleInputChange(e)}
                            name="Email"
                            label="Email"
                            defaultValue={cliente.Email}
                          />
                        </Grid>
                        <Grid xs={12} item md={6}>
                          <Box sx={{ display: "flex", gap: 1 }}>
                            <TextField
                              id="referente-paghe"
                              fullWidth
                              disabled
                              name="NomeReferente"
                              label="Referente Paghe"
                              value={cliente.NomeReferente || ""}
                              sx={{
                                "& .MuiInputBase-input.Mui-disabled": {
                                  WebkitTextFillColor: "#000000",
                                },
                              }}
                            />
                            {sessionStorage.getItem("Autorizzazione") === "1" &&
                              cliente.NomeReferente && (
                                <Tooltip title="Rimuovi referente paghe">
                                  <Button
                                    color="error"
                                    variant="outlined"
                                    aria-label="Rimuovi referente paghe"
                                    onClick={() =>
                                      setOpenRemovePayrollContact(true)
                                    }
                                    sx={{ minWidth: 48 }}
                                  >
                                    <DeleteOutline />
                                  </Button>
                                </Tooltip>
                              )}
                          </Box>
                        </Grid>
                      </Grid>
                      <Grid xs={12} item md={3} sx={{ mt: { xs: 1, md: 0 } }}>
                        <TextField
                          id="standard-basic"
                          fullWidth
                          onChange={(e) => handleInputChange(e)}
                          name="CF"
                          label="Codice Fiscale"
                          defaultValue={cliente.CF}
                        />
                      </Grid>
                      <Grid xs={12} item md={3} sx={{ mt: { xs: 1, md: 0 } }}>
                        <TextField
                          fullWidth
                          label="Codice Ago"
                          name="CodiceAgo"
                          type="text"
                          value={cliente.CodiceAgo ?? ""}
                          inputProps={{ maxLength: 16 }}
                          onBlur={(e) => {
                            const codiceAgo = formatCodiceAgo(e.target.value);
                            setCliente((previous) => ({
                              ...previous,
                              CodiceAgo: codiceAgo,
                            }));
                          }}
                          helperText="Numerici: 15 cifre con zeri iniziali. Massimo 16 caratteri."
                          onChange={(e) => handleInputChange(e)}
                        />
                      </Grid>
                    </Grid>

                    {/* Seconda Riga */}
                    <Grid
                      container
                      sx={{
                        p: 0,
                        display: "flex",
                        columnGap: "10px",
                        flexWrap: { xs: "wrap", md: "nowrap" },
                        mt: 1,
                      }}
                    >
                      <Grid xs={12} item md={6}>
                        <TextField
                          id="standard-basic"
                          fullWidth
                          onChange={(e) => handleInputChange(e)}
                          name="PIVA"
                          label="Partita IVA"
                          defaultValue={cliente.PIVA}
                        />
                      </Grid>
                      <Grid xs={12} item md={6} sx={{ mt: { xs: 1, md: 0 } }}>
                        <TextField
                          id="standard-basic"
                          fullWidth
                          onChange={(e) => handleInputChange(e)}
                          name="Telefono"
                          label="Telefono"
                          defaultValue={cliente.Telefono}
                        />
                      </Grid>
                    </Grid>
                    {/* Terza Riga */}
                    <Grid
                      container
                      sx={{
                        p: 0,
                        display: "flex",
                        columnGap: "10px",
                        flexWrap: { xs: "wrap", md: "nowrap" },
                        mt: 1,
                      }}
                    >
                      <Grid xs={12} item md={6}>
                        <TextField
                          id="standard-basic"
                          fullWidth
                          onChange={(e) => handleInputChange(e)}
                          name="CodiceATECO"
                          label="Codice Ateco"
                          defaultValue={cliente.CodiceATECO}
                        />
                      </Grid>
                      <Grid xs={12} item md={6} sx={{ mt: { xs: 1, md: 0 } }}>
                        <TextField
                          id="standard-basic"
                          fullWidth
                          onChange={(e) => handleInputChange(e)}
                          name="CDC"
                          label="Centro di costo"
                          defaultValue={cliente.CDC}
                        />
                      </Grid>
                    </Grid>
                  </Card>
                  <hr
                    style={{
                      height: "2px",
                      marginTop: "10px",
                      marginBottom: "5px",
                      width: "100%",
                    }}
                  />
                  {/* Body Container */}
                  <Grid
                    container
                    item
                    xs={12}
                    md={12}
                    component={Card}
                    sx={{
                      p: 0,
                      display: "flex",
                      flexWrap: { xs: "wrap", md: "nowrap" },
                      boxShadow: "none",
                      columnGap: { xs: 0, md: 1.5 },
                    }}
                  >
                    {/* Sede Container */}
                    <Grid
                      item
                      xs={12}
                      container
                      md={6}
                      rowGap={{ xs: 0, md: 2 }}
                      sx={{
                        height: "100%",
                        alignItems: "center",
                        display: "flex",
                        flexWrap: "wrap",
                        //mr: { xs: 0, md: 1 },
                        mt: 2,
                      }}
                    >
                      <Grid xs={12} item md={12}>
                        <TextField
                          id="standard-basic"
                          fullWidth
                          onChange={(e) => handleInputChange(e)}
                          name="SedeIndirizzo"
                          label="Sede Indirizzo"
                          defaultValue={cliente.SedeIndirizzo}
                        />
                      </Grid>
                      <Grid xs={12} item md={12} sx={{ mt: { xs: 1, md: 0 } }}>
                        <TextField
                          id="standard-basic"
                          fullWidth
                          onChange={(e) => handleInputChange(e)}
                          name="SedeLocalita"
                          label="Sede Località"
                          defaultValue={cliente.SedeLocalita}
                        />
                      </Grid>
                      <Grid xs={12} item md={12} sx={{ mt: { xs: 1, md: 0 } }}>
                        <TextField
                          id="standard-basic"
                          fullWidth
                          onChange={(e) => handleInputChange(e)}
                          name="SedeCAP"
                          label="Sede CAP"
                          defaultValue={cliente.SedeCAP}
                        />
                      </Grid>
                    </Grid>

                    {/* Posta Container */}
                    <Grid
                      item
                      xs={12}
                      container
                      md={6}
                      rowGap={{ xs: 0, md: 2 }}
                      sx={{
                        height: "100%",
                        alignItems: "center",
                        display: "flex",
                        flexWrap: "wrap",
                        //mx: { xs: 0, md: 1 },
                        mt: 2,
                      }}
                    >
                      <Grid xs={12} item md={12}>
                        <TextField
                          id="standard-basic"
                          fullWidth
                          onChange={(e) => handleInputChange(e)}
                          name="PostIndirizzo"
                          label="Posta Indirizzo"
                          defaultValue={cliente.PostIndirizzo}
                        />
                      </Grid>
                      <Grid xs={12} item md={12} sx={{ mt: { xs: 1, md: 0 } }}>
                        <TextField
                          id="standard-basic"
                          fullWidth
                          onChange={(e) => handleInputChange(e)}
                          name="PostLocalita"
                          label="Posta Località"
                          defaultValue={cliente.PostLocalita}
                        />
                      </Grid>
                      <Grid xs={12} item md={12} sx={{ mt: { xs: 1, md: 0 } }}>
                        <TextField
                          id="standard-basic"
                          fullWidth
                          onChange={(e) => handleInputChange(e)}
                          name="PostCAP"
                          label="Posta CAP"
                          defaultValue={cliente.PostCAP}
                        />
                      </Grid>
                    </Grid>
                  </Grid>

                  <hr
                    style={{
                      height: "2px",
                      marginTop: "10px",
                      marginBottom: "5px",
                      width: "100%",
                    }}
                  />

                  {/* Checkbox Container */}
                  <Card>
                    <Grid
                      item
                      xs={12}
                      container
                      rowGap={{ xs: 0, md: 2 }}
                      sx={{
                        boxShadow: "none",
                        height: "100%",
                        alignItems: "center",
                        display: "flex",
                        flexWrap: "wrap",
                        ml: { xs: 0, md: 1 },
                        mt: 2,
                      }}
                    >
                      <Grid xs={12} item md={6}>
                        <FormControlLabel
                          sx={{ width: "100%" }}
                          control={
                            <Checkbox
                              name="GestioneMedicina"
                              checked={
                                cliente.GestioneMedicina === 1 ? true : false
                              }
                              onChange={(e) => handleCboxChange(e)}
                            />
                          }
                          label="Gestione Medicina"
                        />
                        <FormControlLabel
                          sx={{ width: "100%" }}
                          control={
                            <Checkbox
                              name="GestioneCorsi"
                              checked={
                                cliente.GestioneCorsi === 1 ? true : false
                              }
                              onChange={(e) => handleCboxChange(e)}
                            />
                          }
                          label="Corsi Formazione"
                        />
                        <FormControlLabel
                          sx={{ width: "100%" }}
                          control={
                            <Checkbox
                              name="GestioneSopralluoghi"
                              checked={
                                cliente.GestioneSopralluoghi === 1
                                  ? true
                                  : false
                              }
                              onChange={(e) => handleCboxChange(e)}
                            />
                          }
                          label="Gestione Sopralluoghi"
                        />
                        <FormControlLabel
                          sx={{ width: "100%" }}
                          control={
                            <Checkbox
                              name="InvioSollMedico"
                              checked={
                                cliente.InvioSollMedico === 1 ? true : false
                              }
                              onChange={(e) => handleCboxChange(e)}
                            />
                          }
                          label="Considera Sollecito Idoneità Medici"
                        />
                      </Grid>
                      <Grid xs={12} item md={6}>
                        <ModalNotarization
                          Notarizzato={cliente.Notarizzazione}
                          cliente={cliente}
                          setCliente={setCliente}
                          setOldCliente={setOldCliente}
                        />
                        <FormControlLabel
                          sx={{ width: "100%" }}
                          control={
                            <Checkbox
                              name="FatturaVisiteMediche"
                              checked={
                                cliente.FatturaVisiteMediche === 1
                                  ? true
                                  : false
                              }
                              onChange={(e) => handleCboxChange(e)}
                            />
                          }
                          label="Fattura Visite Mediche"
                        />
                        <FormControlLabel
                          sx={{ width: "100%" }}
                          control={
                            <Checkbox
                              name="Cessato"
                              checked={cliente.Cessato === 1 ? true : false}
                              onChange={(e) => handleCboxChange(e)}
                            />
                          }
                          label="Cessato"
                        />
                        <FormControlLabel
                          sx={{ width: "100%" }}
                          control={
                            <Checkbox
                              name="Sicurezza"
                              checked={cliente.Sicurezza === 1 ? true : false}
                              onChange={(e) => handleCboxChange(e)}
                            />
                          }
                          label="Sicurezza"
                        />
                      </Grid>
                    </Grid>
                  </Card>
                  <Grid
                    xs={12}
                    item
                    sx={{
                      display: "flex",
                      mt: 2,
                      justifyContent: "space-between",
                      width: "100%",
                    }}
                  >
                    <Button
                      variant="contained"
                      className="ButtonMiller"
                      startIcon={<ArrowBack />}
                      onClick={() => navigate(-1)}
                    >
                      INDIETRO
                    </Button>
                    <Button
                      variant="contained"
                      className="ButtonMiller"
                      startIcon={<Check />}
                      onClick={() => saveData()}
                    >
                      Salva
                    </Button>
                  </Grid>
                </Box>
              </TabPanel>
              <TabPanel value={value} index={3}>
                <Lavoratori
                  screenSize={props.screenSize}
                  Lavoratori={lavoratori}
                  idAzienda={clienteId}
                  cliente={cliente}
                  loadLavoratori={reloadLavoratori}
                  loading={loadingLav}
                  ragioneSociale={ragioneSociale}
                />
              </TabPanel>
              <TabPanel
                value={value}
                index={4}
                style={{
                  display:
                    user.Formazione && !user.Medicina && !user.Sicurezza
                      ? "none"
                      : "",
                }}
              >
                <Allegati
                  ragioneSociale={ragioneSociale}
                  screenSize={props.screenSize}
                  idAzienda={clienteId}
                  id={clienteId}
                  colonna="Cliente"
                />
              </TabPanel>
              <TabPanel
                value={value}
                index={5}
                style={{
                  display:
                    user.Formazione && !user.Medicina && !user.Sicurezza
                      ? "none"
                      : "",
                }}
              >
                <MediciCliente
                  screenSize={props.screenSize}
                  // idAzienda={clienteId}
                  idAzienda={clienteId}
                />
              </TabPanel>
              <TabPanel
                value={value}
                index={6}
                style={{
                  display:
                    user.Formazione && !user.Medicina && !user.Sicurezza
                      ? "none"
                      : "",
                }}
              >
                <Mansioni
                  idAzienda={clienteId}
                  ragioneSociale={ragioneSociale}
                />
              </TabPanel>
              <TabPanel
                value={value}
                index={7}
                style={{
                  display:
                    user.Formazione && !user.Medicina && !user.Sicurezza
                      ? "none"
                      : "",
                }}
              >
                {billingAreas?.Medicina && (
                  <BillingAreaGuard area="Medicina">
                    <ContrattiConsulenza
                      key={`coordinamento-${clienteId}`}
                      clienteId={clienteId}
                      coordinamentoSanitario
                    />
                    <FatturazioneMedicina
                      idAzienda={clienteId}
                      cliente={cliente}
                    />
                  </BillingAreaGuard>
                )}
              </TabPanel>
              <TabPanel value={value} index={8}>
                {billingAreas?.Sicurezza && (
                  <BillingAreaGuard area="Sicurezza">
                    <ContrattiConsulenza
                      clienteId={clienteId}
                      onApriUscite={() =>
                        handleChange(
                          null,
                          cliente?.Gruppo === "Gavio" ? 13 : 12,
                        )
                      }
                    />
                  </BillingAreaGuard>
                )}
              </TabPanel>
              <TabPanel
                value={value}
                index={9}
                style={{
                  display: user.Medicina && !user.Formazione ? "none" : "",
                }}
              >
                {billingAreas?.Formazione && (
                  <CorsiCliente
                    idAzienda={clienteId}
                    RagioneSociale={ragioneSociale}
                  />
                )}
              </TabPanel>
              <TabPanel
                value={value}
                index={10}
                style={{
                  display:
                    user.Formazione && !user.Medicina && !user.Sicurezza
                      ? "none"
                      : "",
                }}
              >
                <Sopralluoghi idAzienda={clienteId} />
              </TabPanel>

              {cliente?.Gruppo === "Gavio" && (
                <TabPanel value={value} index={11}>
                  {billingAreas?.Medicina && (
                    <BillingAreaGuard area="Medicina">
                      <ExtraMedici idAzienda={clienteId} />
                    </BillingAreaGuard>
                  )}
                </TabPanel>
              )}
              <TabPanel
                value={value}
                index={cliente?.Gruppo === "Gavio" ? 12 : 11}
              >
                <Memo idAzienda={clienteId} />
              </TabPanel>
              <TabPanel
                value={value}
                index={cliente?.Gruppo === "Gavio" ? 13 : 12}
              >
                {billingAreas?.Sicurezza && (
                  <UsciteTecnici key={clienteId} clienteId={clienteId} />
                )}
              </TabPanel>
              <TabPanel
                value={value}
                index={cliente?.Gruppo === "Gavio" ? 14 : 13}
              >
                <ExtraClienti
                  key={`extra-${clienteId}`}
                  clienteId={clienteId}
                />
              </TabPanel>
              <TabPanel
                value={value}
                index={cliente?.Gruppo === "Gavio" ? 15 : 14}
              >
                {Object.values(extraAccess?.aree || {}).some(Boolean) && (
                  <ExtraClienti
                    key={`fatt-extra-${clienteId}`}
                    clienteId={clienteId}
                    riepilogo
                  />
                )}
              </TabPanel>
            </Box>
          </CardContent>
        </Card>
      </Grid>
    </>
  );
};

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

export default ClientDetail;

function CircularProgressWithLabel(props) {
  const value = Number(props.value) || 0;

  return (
    <Box sx={{ position: "relative", display: "inline-flex" }}>
      <CircularProgress
        variant="determinate"
        thickness={7}
        {...props}
        value={value}
        sx={{
          color: value <= 50 ? "#FF2768" : value <= 75 ? "#2265B1" : "#40C18F",
        }}
      />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: "absolute",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography component="div" color="text.secondary" variant="h5">
          {`${Math.round(value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

const ModalNotarization = (props) => {
  const [open, setOpen] = React.useState(false);
  const [cliente, setCliente] = useState(null);
  const [saveError, setSaveError] = useState("");
  const handleClickOpen = () => {
    setSaveError("");
    setOpen(true);
    setCliente(props.cliente);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleInputChange = (e) => {
    let copiaCliente = { ...cliente };
    copiaCliente[e.target.name] = e.target.value;

    setCliente(copiaCliente);
  };

  const handleSave = async (e) => {
    try {
      await unsplash
        .post(
          "updateClienti",
          { auth: "a5d42c3ed7977afa2d8e922569e7940b", cliente: cliente },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          },
        )
        .then((res) => {});

      await unsplash
        .post(
          "storico",
          {
            tabella: "Clienti",
            key: cliente.ID,
            utente: sessionStorage.getItem("username"),
            after: cliente,
            before: props.cliente,
            operazione: "Modifica",
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("jwt")}`,
            },
          },
        )
        .then((res) => {});
      /*  setSnack({
        severity: "success",
        messaggio: "Cliente salvato con successo",
      });
      setOpenSnack(true); */
      props.setOldCliente(cliente);
      props.setCliente(cliente);
    } catch (error) {
      setSaveError(
        error.response?.data?.message || "Errore durante il salvataggio",
      );
      return;
    }
    setOpen(false);
  };

  return (
    <div>
      <Button
        variant="contained"
        className="ButtonMiller"
        startIcon={
          <Circle
            style={{ color: props.Notarizzato === 0 ? "#FF2768" : " #40C18F" }}
          />
        }
        onClick={() => handleClickOpen()}
      >
        {props.Notarizzato === 0
          ? "Notarizzazione non attiva"
          : "Notarizzazione attiva"}
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        TransitionComponent={Transition}
        fullWidth={true}
        maxWidth="md"
      >
        <DialogTitle id="alert-dialog-title">
          Gestione Notarizzazione
        </DialogTitle>
        <DialogContent>
          {saveError && <Alert severity="error">{saveError}</Alert>}
          <Grid container spacing={2} style={{ paddingTop: "10px" }}>
            <Grid item xs={12} md={6}>
              <FormControl fullWidth>
                <InputLabel id="demo-simple-select-label">
                  Notarizzazione
                </InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={cliente?.Notarizzazione}
                  label="Notarizzazione"
                  onChange={(e) => {
                    let c = { ...cliente };
                    c.Notarizzazione = e.target.value;
                    setCliente(c);
                  }}
                >
                  <MenuItem value={0}>No</MenuItem>

                  <MenuItem value={1}>Parziale</MenuItem>
                  <MenuItem value={2}>Completa</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                id="standard-basic"
                fullWidth
                onChange={(e) => handleInputChange(e)}
                name="NotarizzazioniMensili"
                label="Notarizzazioni Mensili"
                defaultValue={cliente?.NotarizzazioniMensili}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <LocalizationProvider dateAdapter={DateAdapter}>
                <DatePicker
                  ampmInClock={false}
                  renderInput={(props) => (
                    <TextField fullWidth required {...props} />
                  )}
                  label="Data Inizio Notarizzazione"
                  value={moment(cliente?.DataInizioNotarizzazione)}
                  onChange={(newValue) => {
                    let l = { ...cliente };
                    l.DataInizioNotarizzazione = newValue
                      ? newValue.format("YYYY-MM-DD")
                      : null;
                    setCliente(l);
                    //setDal(newValue?newValue.format("YYYY-MM-DD"):null);
                  }}
                />
              </LocalizationProvider>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>annulla</Button>
          <Button onClick={handleSave}>Conferma</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};
